import React from 'react';

export const CreateEmailExclusionJobContext = React.createContext({
  progress: {},
  isUploading: false,
});

export const useCreateEmailExclusionContext = () => {
  return React.useContext(CreateEmailExclusionJobContext);
};
